import { getSessionStorage } from "@jti/rest-api";
import { dispatchTrackingEvent, TrackingEvents, } from "@jti/tracker";
import { CheckOutSteps } from "../../constants/checkout-constants";
import { useFreeTrial } from "../../hooks/useFreeTrial";
import firstLetterCapitalize from "../../utils/firstLetterCapitalize";
import { buildCommerceBaseData } from "./trackingHelpers";
export const getTemplateName = (pathname) => {
    return {
        section: pathname,
        template_name: pathname,
        checkout_type: pathname,
    };
};
export const useGtm = () => {
    const { isFreeTrial } = useFreeTrial();
    const templateName = isFreeTrial ? "free-trial-checkout" : "checkout";
    const sharedData = getTemplateName(templateName);
    const promiseTimeoutInMs = 15000;
    const dispatchGtmPageViewEvent = (template = templateName) => {
        dispatchTrackingEvent(TrackingEvents.TrackingCheckoutPageView, {
            section: template,
            template_name: template,
            checkout_type: templateName,
        });
    };
    const dispatchGtmCheckoutBegin = (trackingData) => {
        if (!trackingData) {
            return;
        }
        const data = {
            section: sharedData.section,
            template_name: sharedData.template_name,
            ...buildCommerceBaseData(trackingData),
        };
        dispatchTrackingEvent(TrackingEvents.TrackingCheckoutBeginCheckout, data);
    };
    const dispatchGtmCheckoutProgress = (trackingData, step) => {
        if (!step || !trackingData) {
            return;
        }
        const stepIndex = Object.keys(CheckOutSteps).indexOf(firstLetterCapitalize(step));
        if (!stepIndex) {
            dispatchGtmCheckoutBegin(trackingData);
        }
        const checkoutProgressData = {
            ...sharedData,
            ...buildCommerceBaseData(trackingData),
            checkout_step_name: step,
            checkout_step_number: stepIndex + 1,
        };
        dispatchTrackingEvent(TrackingEvents.TrackingCheckoutProgress, checkoutProgressData);
    };
    const dispatchGtmAddPaymentInfo = (cart, code) => {
        if (!cart || !code) {
            return;
        }
        const checkoutAddPaymentInfoData = {
            ...sharedData,
            ...buildCommerceBaseData(cart),
            payment_type: code,
        };
        dispatchTrackingEvent(TrackingEvents.TrackingCheckoutAddPaymentInfo, checkoutAddPaymentInfoData);
    };
    const dispatchGtmShippingInfo = (cart, method) => {
        if (!cart) {
            return;
        }
        const checkoutAddShippingInfoData = {
            section: sharedData.section,
            template_name: sharedData.template_name,
            ...buildCommerceBaseData(cart),
            shipping_tier: method.carrierCode,
        };
        dispatchTrackingEvent(TrackingEvents.TrackingCheckoutAddShippingInfo, checkoutAddShippingInfoData);
    };
    const dispatchGtmOrderSummaryPurchase = (order) => {
        if (!order) {
            return;
        }
        const orderConfirmationTemplate = isFreeTrial
            ? "free-trial-order-confirmation-page"
            : "order-confirmation";
        dispatchGtmPageViewEvent(orderConfirmationTemplate);
        const { currency, value, ecommerce } = buildCommerceBaseData(order);
        const purchaseData = {
            ...sharedData,
            currency,
            value,
            ecommerce: {
                ...ecommerce,
                coupon: "N/A",
                shipping: order.shippingMethod.methodCode,
                tax: String(order.total_after_trial.tax?.value || "N/A"),
                value: String(value),
                transaction_id: order.orderId,
            },
        };
        dispatchTrackingEvent(TrackingEvents.TrackingOrderSummaryPurchase, purchaseData);
    };
    const updateGtmPageName = async (template) => {
        const gtmContainer = document.getElementById("gtmContainer");
        if (gtmContainer) {
            await new Promise((resolve, reject) => {
                const interval = setInterval(() => {
                    if (getSessionStorage().get("gtmInstance", "")) {
                        resolve(template);
                    }
                }, 500);
                setTimeout(() => {
                    reject(new Error("GTM instance is unavailable"));
                    clearInterval(interval);
                }, promiseTimeoutInMs);
            });
            gtmContainer.dataset.pageName = template;
        }
    };
    return {
        dispatchGtmCheckoutProgress,
        dispatchGtmCheckoutBegin,
        dispatchGtmAddPaymentInfo,
        dispatchGtmOrderSummaryPurchase,
        dispatchGtmShippingInfo,
        dispatchGtmPageViewEvent,
        updateGtmPageName,
    };
};
//# sourceMappingURL=useGtm.js.map